<template>
	<div class="side-quests lok-scrollbar">
		<ToastMessage
			class="pin-message"
			:show-message="!!pinStatus"
			:message="pinStatus ?? ''"
			uppercase
		/>
		<QuestBox
			v-for="(quest, i) in activeSideQuests"
			:quest="quest"
			:key="i"
			@action="emit('action')"
			@claim-rewards="emit('claimRewards', $event)"
			@pin-action="pinAction($event)"
		/>
		<div v-if="!activeSideQuests?.length" class="no-quest-texts">
			<div>{{ translate("ui.no_active_quest") }}</div>
			<div>
				{{ translate("ui.explore_map_for_quests") }}
				<AppMainIcon iconName="quest-side" :icon-size="24" />
			</div>
		</div>
		<AppTextButton
			:text="translate('button.chronicle')"
			@click="handleChronicleOpen"
		/>
	</div>
</template>

<script lang="ts" setup>
import AppMainIcon from "@/components/AppMainIcon.vue";
import AppTextButton from "@/components/AppTextButton.vue";
import QuestBox from "@/components/Quests/QuestBox.vue";
import ToastMessage from "@/components/ToastMessage.vue";
import { QuestTypes } from "@/game/entities/config/quests/quest_types.js";
import SoundService from "@/game/SoundService";
import useQuestStore from "@/store/useQuestStore";
import type { QuestActive, QuestPinStatus } from "@/types/quest";
import { translate } from "@/utils/translate";
import { storeToRefs } from "pinia";
import { computed, markRaw, ref } from "vue";

const emit = defineEmits(["popup", "action", "claimRewards"]);

const soundService = markRaw(SoundService.getInstance());

const { getActiveQuests } = storeToRefs(useQuestStore());

const pinStatus = ref<string | null>(null);

const activeSideQuests = computed(
	(): Array<QuestActive> | null =>
		getActiveQuests.value.filter(
			(q: QuestActive): boolean => q.type === QuestTypes.SIDE,
		) || null,
);

const handleChronicleOpen = (): void => {
	soundService.playGenerickClick();
	emit("popup", "chronicle");
};

const pinAction = (status: { pinStatus: QuestPinStatus }): void => {
	pinStatus.value = status.pinStatus;
	setTimeout((): void => {
		pinStatus.value = null;
	}, 1_000);
};
</script>

<style lang="scss" scoped>
.side-quests {
	width: 100%;
	@include flex-col-start;
	position: relative;
	gap: 1rem;
	padding: 1rem;

	.no-quest-texts {
		@include flex-col-center;
		div {
			display: flex;
		}
	}
	.pin-message {
		position: absolute;
		top: 0;
		right: 0.6rem;
	}
}
</style>
